module.exports = __webpack_public_path__ + "static/media/IMG-20201016-WA0026.06eb1743.jpg";